import React from 'react';
import CharacterSetControl from '../CharacterSetControl/CharacterSetControl';

const playerControls = (props) => {
  const classes = ['playerControls'];
  return (
    <div className={classes.join(' ')}>
      <CharacterSetControl
        active={props.active}
        visible={props.characterSet !== 'unknown'}
        characterSet={props.translatedCharacterSet}
        isTranslated={props.isTranslated}
        onTranslate={props.onTranslate} />
    </div>
  );
};

export default playerControls;
